import { Injectable, Type } from '@angular/core';
import { Task } from '../../../shared/entities/task/task';
import { ControlTemplate } from '../../form/entities/controlTemplate';
import { TaskFormHandler } from './task-form-handler.interface';
import { DefaultFormViewComponent } from './components/default-form-view.component';

/**
 * Default handler for tasks with no form or unknown form keys.
 * This handler is used as a fallback when no specific handler is found.
 */
@Injectable()
export class DefaultFormHandler implements TaskFormHandler {
  readonly formKey = 'default';

  canHandle(formKey: string): boolean {
    // Default handler matches when formKey is null, undefined, or 'default'
    return !formKey || formKey === this.formKey;
  }

  getComponent(): Type<any> | null {
    return DefaultFormViewComponent;
  }

  initialize(task: Task, template: ControlTemplate | null): void {
    // No form to initialize - just prepare for simple completion
    console.log('[DefaultFormHandler] Initializing for task:', task.id, '(no form)');
  }

  destroy(): void {
    // Minimal cleanup needed for default handler
    console.log('[DefaultFormHandler] Destroying handler');
  }
}
